import React, { useState } from 'react';

import styled from '@emotion/styled';

import { ClickOutDropDown } from '../../../components/DropDown/ClickOutDropDown';
import BriefCaseIcon from '../../../components/Icons/BriefCaseIcon';
import { ChevronDown } from '../../../components/Icons/ChevronDown';
import LogOutIcon from '../../../components/Icons/LogOutIcon';
import ViewHistoryIcon from '../../../components/Icons/ViewHistoryIcon';
import { Modal } from '../../../components/Modal/Modal';
import CannotUpdateDriverPerformanceModal from '../../../components/Modal/ModalActions/CannotUpdateDriverPerformanceModal/CannotUpdateDriverPerformanceModal';
import ExitDispatcherModal from '../../../components/Modal/ModalActions/ExitDispatcherModal/ExitDispatcherModal';
import ExitFullHistoryModal from '../../../components/Modal/ModalActions/ExitFullHistoryModal/ExitFullHistoryModal';
import UpdateDriverPerformanceModal from '../../../components/Modal/ModalActions/UpdateDriverPerformanceModal/UpdateDriverPerformanceModal';
import { DriverDetailsDataType } from '../../../hooks/dashboard/driver-list/useDriverDetails';

interface MangeDriverDropDownProps {
  data: any;
  driverDetailsData?: DriverDetailsDataType | null;
  setRefreshData: React.Dispatch<React.SetStateAction<number>>;
}
const MangeDriverDropDown: React.FC<MangeDriverDropDownProps> = ({
  data,
  driverDetailsData,
  setRefreshData,
}) => {
  const [showExitModal, setShowExitModal] = useState(false);
  const [showExitHistoryModal, setShowExitHistoryModal] = useState(false);
  const [showListVehicleModal, setShowListVehicleModal] = useState(false);

  return (
    <Container>
      <ClickOutDropDown
        posRight='0px'
        maxHeight='170px'
        label={
          <DropDownLabel>
            Manage Performance <ChevronDown />
          </DropDownLabel>
        }
      >
        <DropDownContent>
          <DivCell onClick={() => setShowListVehicleModal(true)}>
            <BriefCaseIcon />
            Update Performance
          </DivCell>
          {data.verificationStatus !== 'Pending' && (
            <DivCell onClick={() => setShowExitHistoryModal(true)}>
              <ViewHistoryIcon />
              View Exit History
            </DivCell>
          )}

          {data?.verificationStatus !== 'Pending' && (
            <DivCell className='red' onClick={() => setShowExitModal(true)}>
              <LogOutIcon /> Exit Driver
            </DivCell>
          )}
        </DropDownContent>
      </ClickOutDropDown>
      <Modal
        showModal={showListVehicleModal}
        setShowModal={setShowListVehicleModal}
      >
        {data?.assignedFleet ? (
          <UpdateDriverPerformanceModal
            data={driverDetailsData}
            setRefreshData={setRefreshData}
          />
        ) : (
          <CannotUpdateDriverPerformanceModal />
        )}
      </Modal>

      <Modal showModal={showExitModal} setShowModal={setShowExitModal}>
        <ExitDispatcherModal data={data} />
      </Modal>
      <Modal
        showModal={showExitHistoryModal}
        setShowModal={setShowExitHistoryModal}
      >
        <ExitFullHistoryModal />
      </Modal>
    </Container>
  );
};

export default MangeDriverDropDown;

const Container = styled.div``;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #5b91f5;
  border: 1px solid #5b91f5;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
`;

const DropDownContent = styled.div`
  display: flex;
  flex-direction: column;

  background-color: white;
  padding: 4px 0;
  gap: 4px;

  width: 232px;
`;

const DivCell = styled.div`
  padding: 13px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;

  &.red {
    color: #d20832;
  }

  &:hover {
    background-color: #f9fafb;
  }

  /* border: 1px solid red; */

  & > svg {
    /* border: 1px solid blue; */
    width: 20px;
    height: 20px;
  }
`;
